import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';
import { levels, levelsType } from 'src/constants/vars';
import { CourseItemType } from 'src/types/courses';


interface ItemProps {
    item: CourseItemType;
}

function Item({ item }: ItemProps) {
    const navigate = useNavigate();

    return (
        <div
            className={styles.post}
            onClick={() => navigate(`${item.slug}/`)}
        >
            <div className={styles.imgCon}>
                <img src={item.thumbnail} alt={item.name} />
            </div>

            <div className={styles.content}>
                <h4>{item.name}</h4>

                {item.instructor && <div className={styles.insr}>
                    المدرب \ {item.instructor}
                </div>}

                <p className={styles.overview}>
                    {item.overview}
                </p>

                <div className={styles.divider} />

                <div className={styles.footer}>
                    <div className={styles.level}>
                        المستوى /{" "}
                        <span>
                            {levels[item.level as keyof levelsType]}
                        </span>
                    </div>

                    {item.price && item.price !== null && item.price > 0 && <div className={styles.price}>
                        {item.price} د.ل
                    </div>}
                </div>
            </div>
        </div>
    );
}

export default Item;
